const React         = require("react");

const ExportUtil = require("../../util/ExportUtil.js");
const ImportModel   = require("../../util/ImportUtil.js");
const ObservableUtil  = require("../../util/ObservableUtil.js")

const ImportConfirm = require("./ImportConfirm.jsx");
const Spinning      = require("../modals/Loading.jsx");
const IconsPreview  = require("../preview/IconsPreview.jsx");

class ImportVersion extends IconsPreview {

    constructor(){
        super();

        this.state = {overwrite: {show: false, newName: ""}, success: {show: false}}
    
        this.sendUrl = this.sendUrl.bind(this);
        this.saveFile = this.saveFile.bind(this);
        this.sendFile = this.sendFile.bind(this);
        this.checkFile = this.checkFile.bind(this);
        this.goOnVersion = this.goOnVersion.bind(this);
        this.handleWindowFile = this.handleWindowFile.bind(this);
        this.closeInconsisten = this.closeInconsisten.bind(this);
        this.validateImportUrl = this.validateImportUrl.bind(this);
        this.validateImportFile = this.validateImportFile.bind(this);
    }

    componentDidMount(){
        let { source } = this.props;
        if(source.startsWith("file")){
            this.radiof.checked = true;
        }else{
            this.radiou.checked = true;
            this.formText.value = source;
        }
    }
    
    handleWindowFile(){
        this.radiof.checked = true;
        this.importFile.click();
    }
    
    saveFile(event){
        this.file = event.target.files[0];
        this.setState({fileName: this.file.name});
    }

    checkFile(){
        let { id, name } = this.props;
        if(this.radiou.checked){
            if(this.validateImportUrl()){ this.sendUrl(id, name)};
        }else{
            if(this.validateImportFile()){ this.sendFile(id, name)};
        }
    }

    validateImportFile(){
        if(!this.file || !ImportModel.validateFile(this.file)) {
            this.props.handleError(null, 'upload this file', 'Please check that this is a valid library.  Accepts formats lbr, intlib, pcblib, schlib, and olb.')
            return false;
        }
        else if(this.formatName(this.file.name) !== this.props.name){
            this.setState({overwrite: {show: true, method: this.sendFile, newName: this.file.name}});
            return false;
        }
        return true;
    }

    validateImportUrl(){
        let value = this.formText.value.trim();
        let newName = value.slice(value.lastIndexOf("/")+1 , value.lastIndexOf("."));
        if(!ImportModel.validateUrl(value)){
            this.props.handleError(null, "import this library", 'Please check that this is a valid library URL.')
            return false;
        }
        else if(newName.toLowerCase() !== this.props.name.toLowerCase()){
            this.setState({overwrite: {show: true, method: this.sendUrl, newName}});
            return false;
        }
        return true;
    }
    
    formatName(name){
        return name.slice(0, name.lastIndexOf("."))
    }
    
    goOnVersion(id, name){
        this.setState({overwrite: {show: false}});
        this.state.overwrite.method(id, name);
    }

    sendFile(id){
        this.props.switchSpinning({show:true, percent: 0});
        googleGA("send", "event", "library", "uploadNewVersion");
        ImportModel.getFile(this.props.handleError, id, this.file, false)
            .then(() => ImportModel.getStatus(this.props.handleError, id, this.props.switchSpinning))
            .then((info) => this.imported(id, info))
            .catch((err) => {
                this.props.handleError(err, "upload new version");
                this.props.switchSpinning({show:false})
                // the tooltip needs to refresh after successful or failed import attempt
                ObservableUtil.callChangeSubscribers("publish", id);
            })
        }

    sendUrl(id){
        this.props.switchSpinning({show:true, percent: 0});
        googleGA("send", "event", "library", "uploadurlNewVersion");
        ImportModel.getUrl(this.props.handleError, id, this.formText.value.trim(), false)
            .then(() => ImportModel.getStatus(this.props.handleError, id, this.props.switchSpinning))
            .then((info) => this.imported(id, info))
            .catch((err) => {
                this.props.handleError(err, "upload new version");
                this.props.switchSpinning({show:false})
                // the tooltip needs to refresh after successful or failed import attempt
                ObservableUtil.callChangeSubscribers("publish", id);
            })
    }

    imported(id, info){
        console.log(info);
        this.props.switchSpinning({show:false});
        this.setState({success: { show: true}});
        // the tooltip needs to refresh after successful or failed import attempt
        ObservableUtil.callChangeSubscribers("publish", id);
        // Export library after version is imported. Export is needed in order to get children data (searching libraries by component names)
        ExportUtil.exportLibrary(() => {}, info);
    }

    closeInconsisten(show = false){
        this.setState({overwrite: {show}})
    }

    render() {
        let { id, name, onClose, switchSpinning } = this.props;

        return  <React.Fragment>
                    <div className="newVersion library">
                        <section className="">
                            <h1 className="newVersion__title"> Upload New Version </h1>
                            <p className="">Upload a new version of library <span className="newVersion__name">{name}</span>. This will overwrite the devices, symbols, and footprints in the library. 3D models will be retained. </p>
                            <div className="newVersion__separator"></div>

                            <div className="newVersion__row">
                                <label className="radioContainer">
                                    <input id="file" name="type" type="radio" ref={radio => this.radiof = radio}/>
                                    <span className="checkmark"></span>
                                </label>
                                <label htmlFor="file">Upload from file:</label>
                                <button className="button gray" onClick={this.handleWindowFile}>Upload File</button>
                                <input id="import__file" type="file" accept=".lbr,.intlib,.pcblib,.schlib,.olb" hidden value="" 
                                    ref={input => this.importFile = input} onChange={this.saveFile}/>
                                <span className="newVersion__row__fileName">{this.state.fileName}</span>
                            </div>

                            <div className="newVersion__row">
                                <label className="radioContainer">
                                    <input id="url" name="type" type="radio" ref={radio => this.radiou = radio}/>
                                    <span className="checkmark"></span>
                                </label>
                                <label htmlFor="url">Upload from URL:</label>
                                <input type="text" placeholder="URL to Library" className="" 
                                    ref={input => this.formText = input} />
                            </div>

                            <div className="newVersion__row buttons">
                                <button className="button transparent" onClick={onClose}>Cancel</button>
                                <button className="button" onClick={this.checkFile}>Upload</button>
                            </div>
                        </section>
                    </div>

                    <Spinning show={this.state.overwrite.show}>
                        <ImportConfirm id={id} name={name} type="overwrite" 
                            goOnVersion={this.goOnVersion}
                            newName={this.state.overwrite.newName} 
                            closeInconsisten={this.closeInconsisten} />
                    </Spinning>

                    <Spinning show={this.state.success.show}>
                        <ImportConfirm id={id} name={name} type="success" switchSpinning={switchSpinning}/>
                    </Spinning>
                </React.Fragment>
    }
}

module.exports = ImportVersion;
